import React from 'react';
import Services from '../components/Services';
import ServiceAreas from '../components/ServiceAreas';

const ServicesPage = ({ onContactClick }) => {
  return (
    <>
      <Services onContactClick={onContactClick} />
      <ServiceAreas />
    </>
  );
};

export default ServicesPage;
